import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { handleSessionExpiry, isSessionValid } from '../../utils/auth';

function SessionChecker() {
  const navigate = useNavigate();

  useEffect(() => {
    // Support multi-tab logout
    const onStorage = (e) => {
      if ((e.key === 'userToken' || e.key === 'userId' || e.key === 'token') && e.oldValue && !e.newValue) {
        alert('Session expired. कृपया पुन्हा लॉगिन करा.');
        navigate('/login');
      }
    };

    window.addEventListener('storage', onStorage);

    const interval = setInterval(() => {
      if (!isSessionValid()) {
        handleSessionExpiry(navigate);
      }
    }, 60000); // every minute

    return () => {
      clearInterval(interval);
      window.removeEventListener('storage', onStorage);
    };
  }, [navigate]);

  // ✅ Reset timer on any user activity
  useEffect(() => {
    const resetLoginTime = () => {
      localStorage.setItem('loginTime', Date.now().toString());
    };

    window.addEventListener('mousemove', resetLoginTime);
    window.addEventListener('keydown', resetLoginTime);
    window.addEventListener('scroll', resetLoginTime);
    window.addEventListener('touchstart', resetLoginTime);

    return () => {
      window.removeEventListener('mousemove', resetLoginTime);
      window.removeEventListener('keydown', resetLoginTime);
      window.removeEventListener('scroll', resetLoginTime);
      window.removeEventListener('touchstart', resetLoginTime);
    };
  }, []);

  return null;
}

export default SessionChecker;
